import React from 'react';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

const ForgotPasswordConfirmation = ({ classes }) => {
  const goHome = () => window.location.href = process.env.REACT_APP_HOMEPAGE_URL;

  return (
    <div className={classes.container}>
      <Grid container spacing={8} className={classes.containerForm}>

        <Grid item xs={12}>
          <h2 className={classes.headerText}>We've sent you an email.</h2>

          <p className={classes.subtext}>
            You will receive an email with instructions on how to get a new password.
          </p>

          <p className={classes.subtext}>
            <Button
              onClick={goHome}
              color="primary"
              variant="contained"
              className={classes.submitButton}
            >
              Go Back Home
            </Button>
            </p>
        </Grid>
      </Grid>
    </div>
  );
};

const styles = () => ({
  container: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    alignItems: 'center',
  },
  containerForm: {
    width: '50%',
    padding: '1rem',
    paddingTop: '90px',
    '@media only screen and (max-width: 1024px)': {
      width: '100%',
    },
  },
  headerText: {
    color: '#1C1C1C',
    fontSize: '40px',
    fontWeight: '300',
    lineHeight: '47px',
    paddingBottom: '25px',
  },
  subtext: {
    color: '#1C1C1C',
    fontSize: '16px',
    lineHeight: '24px',
    paddingBottom: '25px',
  },
});

export default withStyles(styles)(ForgotPasswordConfirmation);
